import loadable from '@loadable/component'

export const Product = loadable(() => import('./Product'))

export { default as Category } from './Category'
export { default as Layout } from './Layout'
